// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './store/firebase'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'vuetify/dist/vuetify.min.css'
import 'vue-awesome-notifications/dist/styles/style.css'
import './main.css'
import StackdriverErrorReporter from 'stackdriver-errors-js/stackdriver-errors'
import { initJira } from './utils/jira'

import Vue from 'vue'
import VueFire from 'vuefire'
import Vuetify from 'vuetify'
import VuetifyPt from 'vuetify/es5/locale/pt'
import VueObserveVisibility from 'vue-observe-visibility'
import AsyncComputed from 'vue-async-computed'
import confirmDialog from 'vuetify-vuejs-confirmdialog'
import VueGoogleCharts from 'vue-google-charts'
import VueSweetalert2 from 'vue-sweetalert2'
import VueAWN from 'vue-awesome-notifications'
import Editor from '@tinymce/tinymce-vue'
import Money from 'v-money'

import CKEditor from '@ckeditor/ckeditor5-vue'
import App from './App'
import { store } from './store'
import router from './router'
import filters from './utils/filters'
import mixins from './utils/mixins'
import i18n from './i18n'
import moment from 'moment'
import UForm from '@/components/form/form.vue'
// import env from 'process.env'

moment.locale('pt-br')
initJira()

Vue.use(Money)
Vue.use(VueFire)
Vue.use(VueSweetalert2)
Vue.use(VueAWN, {
  position: 'top-right',
  labels: {
    // tip: 'Tip',
    info: 'Aviso',
    success: 'Sucesso',
    warning: 'Atenção',
    alert: 'Erro',
    async: 'Carregamdp',
    confirm: 'Necessária confirmação',
    confirmOk: 'OK',
    confirmCancel: 'Cancelar'
  },
  messages: {
    async: 'Por favor, aguarde...',
    'async-block': 'Carregando...'
  }
})
Vue.use(Vuetify, {
  lang: {
    locales: { pt: VuetifyPt },
    current: 'pt'
  },
  theme: {
    primary: '#199995'
    // secondary: '#424242',
    // accent: '#82B1FF',
    // error: '#FF5252',
    // info: '#2196F3',
    // success: '#4CAF50',
    // warning: '#FFC107'
  }})
Vue.use(filters)
Vue.use(mixins)
Vue.use(VueObserveVisibility)
Vue.use(AsyncComputed)
Vue.use(confirmDialog)
Vue.use(VueGoogleCharts)
Vue.use(CKEditor)
Vue.component('UForm', UForm)

Vue.component('tinymce-editor', Editor)

Vue.config.productionTip = false

// console.log({env})

// if (env === 'production') {
var errorHandler = new StackdriverErrorReporter()
errorHandler.start({
  key: 'AIzaSyCdxkbdCuyXZH0Od-bp9ZvqwQ5RL_xJSYA',
  projectId: 'ultracarebr'
  // service: 'app',                        // (optional)
  // version: '<my-service-version>',            // (optional)
  // reportUncaughtExceptions: false          // (optional) Set to false to stop reporting unhandled exceptions.
  // reportUnhandledPromiseRejections: false  // (optional) Set to false to stop reporting unhandled promise rejections.
  // disabled: true                           // (optional) Set to true to not report errors when calling report(), this can be used when developing locally.
  // context: {user: 'user1'}                 // (optional) You can set the user later using setUser()
})

window.errorHandler = errorHandler
// }

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js